import { render, staticRenderFns } from "./EmptyResourceInformationPlaceholderNew.vue?vue&type=template&id=2ec361bc"
import script from "./EmptyResourceInformationPlaceholderNew.vue?vue&type=script&lang=ts"
export * from "./EmptyResourceInformationPlaceholderNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec361bc')) {
      api.createRecord('2ec361bc', component.options)
    } else {
      api.reload('2ec361bc', component.options)
    }
    module.hot.accept("./EmptyResourceInformationPlaceholderNew.vue?vue&type=template&id=2ec361bc", function () {
      api.rerender('2ec361bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EmptyResourceInformationPlaceholderNew.vue"
export default component.exports